/* eslint-disable camelcase */
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { configsSelector } from '../../../store/reducers/servicesConfigs';
import { imageStateSelector } from '../../../store/reducers/image';
import { fetchImage } from '../../../store/actions/image';
import { flagsSelector } from '../../../store/reducers/flags';

export default (
  predictionsToView,
  loading,
  onDeleteSamples,
  onMakePredictionByImage,
  clearPredictionsList,
  onRelabelSample,
  currentConfig
) => {
  const totalImages = predictionsToView.length;
  const dispatch = useDispatch();
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const configs = useSelector(configsSelector);
  const imageState = useSelector(imageStateSelector);
  const flags = useSelector(flagsSelector);
  const config = configs[currentConfig];
  const prediction = predictionsToView[currentImageIndex] ?? {};
  const {
    uuid = '',
    created_at = '',
    label = '',
    // path = '',
  } = prediction;
  const predictionDetails = [
    {
      title: 'uuid',
      value: uuid,
    },
    {
      title: 'Predicted at',
      value: created_at
        ? moment(created_at).format('MMM, DD, YYYY, HH:mm:ss')
        : '',
    },
    {
      title: 'GT',
      value: label,
    },
  ];

  const imageLoading = imageState?.loading;
  const src = imageState?.image?.image
    ? `data:image/jpeg;base64,${imageState?.image?.image}`
    : undefined;

  useEffect(() => {
    if (uuid) {
      dispatch(fetchImage(config, uuid, flags));
    }
  }, [dispatch, uuid, flags]);

  const onPrevClick = () => {
    const newIndex = currentImageIndex
      ? currentImageIndex - 1
      : totalImages - 1;
    setCurrentImageIndex(newIndex);
    clearPredictionsList();
  };

  const onNextClick = () => {
    setCurrentImageIndex((currentImageIndex + 1) % totalImages);
    clearPredictionsList();
  };

  const onDeleteSample = () => {
    onDeleteSamples([uuid]);
  };

  const onRelabelSampleUuid = () => {
    onRelabelSample(uuid);
  };

  const onRunPrediction = () => {
    if (src && !loading) {
      (async () => {
        // const dataUrl = await toDataURL(src);
        const dataUrl = src;
        const imageBase64 = dataUrl.split('base64,')[1];
        onMakePredictionByImage(imageBase64);
      })();
    }
  };

  useEffect(() => {
    const onKeyDown = (event) => {
      if (!totalImages) return;
      switch (event.keyCode) {
        case 37:
          onPrevClick();
          break;
        case 39:
          onNextClick();
          break;
        case 16:
          onRunPrediction();
          break;
        default:
      }
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [currentImageIndex, totalImages]);

  useEffect(() => {
    clearPredictionsList();
    if (!totalImages || totalImages === currentImageIndex) {
      setCurrentImageIndex(0);
    }
  }, [totalImages]);

  return {
    src,
    loading,
    imageLoading,
    currentImageNumber: currentImageIndex + 1,
    totalImages,
    predictionDetails,
    onNextClick,
    onPrevClick,
    onDeleteSample,
    onRunPrediction,
    onRelabelSampleUuid,
  };
};
